import React from "react";
import PropTypes from "prop-types";
import AddUnderwritingJobForm from "forms/add-underwriting-job-form";
import UnderwritingJobTable from "./underwriting-job-table";
import { UnderwritingService } from "services";
import { 
    Row,
    Col, 
    Card,
    Button,
    Statistic,
    Slider,
    message
} from "antd";
import { Map, List } from "immutable";
import DistributorsDataTable from "./distributors-data-table";
import { AggregateDistributorData, DistributorDataRecord } from "records/underwriting-record";
import { connect } from "react-redux";
class UnderwritingRequests extends React.Component {
    formRef = React.createRef();
    state = {
        count: 0,
        jobs: new Map({
            list: new Map({}),
            1: new List([])
        }),
        loading: false,
        currentPage: "1",
        jobCurrentPage: 1,
        pageSize: 20,
        jobsPageSize: 10,
        creatingJob: false,
        filters: null,
        summaryRecord: new AggregateDistributorData(),
        minimumLimit: 50000,
        minimumVintage: 1,
        tenor: 30,
        distributorsCount: 0,
        distributors_list: new Map({
            1: new List([])
        })
    };

    componentDidMount() {
        UnderwritingService.getAggregateDistributorData().then((_) => {
            this.setState({
                summaryRecord: this.state.summaryRecord.merge(_.data)
            }, () => {
                UnderwritingService.getAggregateLedgerAnalysis(
                    this.state.minimumLimit,
                    this.state.minimumVintage,
                    this.state.tenor
                ).then(__ => {
                    this.setState({
                        summaryRecord: this.state.summaryRecord.merge(__.data)
                    });
                });
            });
        });
        this.getDistributorList();
        this.getJobList();
    }

    getJobList = () => {
        this.setState(
            {
                loading: true
            },
            () =>
                UnderwritingService.getJobs(
                    this.state.jobCurrentPage,
                    this.state.jobsPageSize
                ).then(({ data, error }) => {
                    if (error) {
                        this.setState({
                            loading: false
                        });
                        return;
                    }
                    const { jobs } = this.state;
                    const newJobs = new List(data.results);
                    this.setState({
                        count: data.count,
                        jobs: jobs
                            .mergeIn(
                                ["list"],
                                newJobs.toMap().mapEntries(([, v]) => [v.id, v])
                            )
                            .set(
                                String(this.state.jobCurrentPage),
                                newJobs.map(_ => _.id)
                            ),
                        loading: false
                    });
                })
        );
    }

    getDistributorList(filter) {
        UnderwritingService.getDistributorData(this.state.currentPage, this.state.pageSize, filter).then(({data}) => {
            this.setState({
                distributorsCount: data.count,
                distributors_list: this.state.distributors_list.set(
                    this.state.currentPage,
                    data.results.length ? 
                        new List(data.results.map(_ => new DistributorDataRecord(_))) :
                        new List([])
                )
            }, () => {
                UnderwritingService.getAggregateLedgerData(
                    this.state.minimumLimit,
                    this.state.minimumVintage,
                    this.state.tenor,
                    this.state.currentPage,
                    this.state.pageSize
                ).then(({data}) => {
                    this.setState({
                        distributors_list: this.state.distributors_list
                            .set(this.state.currentPage, 
                                this.state.distributors_list
                                    .get(this.state.currentPage)
                                    .map(_ => {
                                        let newObj = data && data.find(val => val.ledger_master__seller__gstin === _.distributor_gstin);
                                        const newVal = _.merge(newObj);
                                        return newVal;
                                    })
                            )
                    });
                });
            });
        });
    }

    onPageChange = (page, pageSize) => {
        if (
            this.state.jobs.get(String(page)) &&
            this.state.jobs.get(String(page)).size === Number(pageSize)
        ) {
            this.setState({
                currentPage: String(page),
                pageSize: String(pageSize)
            });
        } else {
            this.setState(
                {
                    currentPage: String(page),
                    pageSize: String(pageSize),
                    loading: true,
                    jobs: this.state.jobs.set(String(page), new List([]))
                },
                () =>
                    this.getDistributorList()
            );
        }
    };

    onJobsPageChange = (page, pageSize) => {
        this.setState({
            jobCurrentPage: page,
            jobsPageSize: pageSize
        }, () => this.getJobList());
    }

    createJob = () => {
        this.formRef.current.validateFields((err, { distributor }) => {
            message.loading("Creating Request", 0);
            if (!err) {
                this.setState(
                    {
                        creatingJob: true
                    },
                    () =>
                        UnderwritingService.createUnderwritingJob({
                            ...distributor,
                        }).then(({ error }) => {
                            message.destroy();
                            if (!error) {
                                message.success("Request Created!");
                                // this.formRef.current.resetFields();
                                UnderwritingService.getJobs(
                                    this.state.currentPage,
                                    this.state.pageSize
                                ).then(({ data, error }) => {
                                    if (error) {
                                        this.setState({
                                            loading: false
                                        });
                                        return;
                                    }
                                    const { jobs } = this.state;
                                    const newJobs = new List(data.results);
                                    this.setState({
                                        count: data.count,
                                        jobs: jobs
                                            .mergeIn(
                                                ["list"],
                                                newJobs.toMap().mapEntries(([, v]) => [v.id, v])
                                            )
                                            .set(
                                                String(this.state.currentPage),
                                                newJobs.map(_ => _.id)
                                            ),
                                        loading: false
                                    });
                                });
                                this.setState({
                                    creatingJob: false
                                });
                            } else {
                                this.setState({
                                    creatingJob: false
                                }, () => {
                                    message.error("Request Creation Failed!");
                                });
                            }
                        }).catch((error) => {
                            message.destroy();
                            this.setState({
                                creatingJob: false
                            }, () => {
                                if(error && error.non_field_errors && error.non_field_errors[0]) {
                                    message.error(error.non_field_errors[0]);
                                }
                            });
                        })
                );
            }
        });
    };

    onFilter = (values) => {
        this.setState({
            filters: values && values.search[0]
        }, () => {
            this.getDistributorList(this.state.filters);
        });
    }

    onFilterChange = (key, value) => {
        this.setState(
            {
                [key]: value,
                loading: true
            },
            () => {
                UnderwritingService.getAggregateLedgerAnalysis(
                    this.state.minimumLimit,
                    this.state.minimumVintage,
                    this.state.tenor
                ).then(_ => {
                    this.setState({
                        summaryRecord: this.state.summaryRecord.merge(_.data),
                        loading: false
                    });
                });
                UnderwritingService.getAggregateLedgerData(
                    this.state.minimumLimit,
                    this.state.minimumVintage,
                    this.state.tenor,
                    this.state.currentPage,
                    this.state.pageSize
                ).then(({data}) => {
                    this.setState({
                        distributors_list: this.state.distributors_list
                            .set(this.state.currentPage, 
                                this.state.distributors_list
                                    .get(this.state.currentPage)
                                    .map(_ => {
                                        let newObj = data && data.find(val => val.ledger_master__seller__gstin === _.distributor_gstin);
                                        const newVal = _.merge(newObj);
                                        return newVal;
                                    })
                            ),
                        loading: false
                    });
                });
            });
    };

    render() {
        return (
            <React.Fragment>
                {
                    this.props.permissions?.get("page_case_underwriting") && <Row className={"p-5"}>
                        <Col span={18} className={"p-5"}>
                            <Card bodyStyle={{
                                height: "380px"
                            }}>
                                <div className={"d-flex flex-wrap p-5"}>
                                    {this.state.summaryRecord && new Map(this.state.summaryRecord.getDisplayData()).map((v, k) => (
                                        <Statistic
                                            key={k}
                                            title={k}
                                            value={v}
                                            className={"mb-10"}
                                            style={{
                                                minWidth: "200px"
                                            }}
                                        />
                                    )).toList().toArray()}
                                </div>
                            </Card>
                        </Col>
                        <Col span={6} className={"p-5"}>
                            <Card>
                                <Row>
                                    <Col span={24}>
                                        <Statistic
                                            title={"Minimum Vintage (in Months)"}
                                            value={this.state.minimumVintage}
                                            className={"mb-10"}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Slider
                                            min={1}
                                            max={100}
                                            onAfterChange={this.onFilterChange.bind(null, "minimumVintage")}
                                            defaultValue={this.state.minimumVintage}
                                            step={1}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Statistic
                                            title={"Minimum Limit (in INR)"}
                                            value={this.state.minimumLimit}
                                            className={"mb-10"}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Slider
                                            min={50000}
                                            max={1000000}
                                            onAfterChange={this.onFilterChange.bind(null, "minimumLimit")}
                                            defaultValue={this.state.minimumLimit}
                                            step={25000}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Statistic
                                            title={"Tenor (in Days)"}
                                            value={this.state.tenor}
                                            className={"mb-10"}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Slider
                                            min={30}
                                            max={90}
                                            onAfterChange={this.onFilterChange.bind(null, "tenor")}
                                            defaultValue={this.state.tenor}
                                            step={15}
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={24} className={"p-5"}>
                            <DistributorsDataTable
                                keyFilter={"id"}
                                onPageChange={this.onPageChange}
                                currentPage={this.state.currentPage}
                                count={this.state.distributorsCount}
                                data={this.state.distributors_list
                                    .get(this.state.currentPage)}
                                onFilter={this.onFilter}
                                loading={this.state.loading}
                                router={this.props.history.push}
                            />
                        </Col>
                        <Col span={24} className={"p-5"}>
                            <Card
                                title={"New Underwriting Job"}
                                extra={[
                                    <Button
                                        key={"create-job"}
                                        type={"primary"}
                                        onClick={this.createJob}
                                    >
                                        Create
                                    </Button>
                                ]}
                                loading={this.state.creatingJob}
                            >
                                <AddUnderwritingJobForm ref={this.formRef} />
                            </Card>
                        </Col>
                        <Col span={24} className={"p-5"}>
                            <UnderwritingJobTable
                                keyFilter={"id"}
                                onPageChange={this.onJobsPageChange}
                                currentPage={this.state.jobCurrentPage}
                                count={this.state.count}
                                data={this.state.jobs
                                    .get("list")
                                    .filter(_ =>
                                        this.state.jobs
                                            .get(String(this.state.jobCurrentPage))
                                            ?
                                            this.state.jobs
                                                .get(String(this.state.jobCurrentPage))
                                                .includes(_.id)
                                            :
                                            new List([])
                                    )
                                    .toList()}
                                onFilter={this.onFilter}
                                router={this.props.history.push}
                            />
                        </Col>
                    </Row>
                }
            </React.Fragment>
        );
    }
}

UnderwritingRequests.propTypes = {
    history: PropTypes.object,
    permissions: PropTypes.object
};

const mapStateToProps = state => ({
    permissions: state.user.get("permissions"),
});

export default connect(
    mapStateToProps
) (UnderwritingRequests);
